/**
 * Configuration keys for typed config access
 */
export var ConfigKey;
(function (ConfigKey) {
    ConfigKey["REGISTRATION"] = "REGISTRATION";
    ConfigKey["PROFILE"] = "PROFILE";
    ConfigKey["I18N"] = "I18N";
    ConfigKey["EXPERIMENTAL"] = "EXPERIMENTAL";
    ConfigKey["INVITE_CODE_SETTINGS"] = "invite_code_settings";
    ConfigKey["AUTH_PAGE_CONFIG"] = "AUTH_PAGE_CONFIG";
    ConfigKey["CAROUSEL_SLIDES"] = "CAROUSEL_SLIDES";
    ConfigKey["HOMEPAGE_SETTINGS"] = "HOMEPAGE_SETTINGS";
    ConfigKey["FOOTER_CONFIG"] = "FOOTER_CONFIG";
    ConfigKey["AI_PROVIDER_CONFIG"] = "AI_PROVIDER_CONFIG";
    ConfigKey["SEO_CONFIG"] = "SEO_CONFIG";
})(ConfigKey || (ConfigKey = {}));
/**
 * 系统配置键名
 */
export var SystemConfigKey;
(function (SystemConfigKey) {
    SystemConfigKey["SYSTEM_INSTALLED"] = "SYSTEM_INSTALLED";
    SystemConfigKey["SYSTEM_NAME"] = "SYSTEM_NAME";
    SystemConfigKey["SYSTEM_LOGO"] = "SYSTEM_LOGO";
    SystemConfigKey["CONTACT_EMAIL"] = "CONTACT_EMAIL";
    SystemConfigKey["CONTACT_PHONE"] = "CONTACT_PHONE";
    SystemConfigKey["CERTIFICATE_ISSUER"] = "CERTIFICATE_ISSUER";
    /** Public-facing site URL (e.g. https://hbqkx.cn), used for QR codes in certificates. Falls back to WEB_URL env var. */
    SystemConfigKey["SITE_URL"] = "SITE_URL";
    /** UI 主题（系统级外观风格，如 glass/flat）。可选值见 UI_THEMES registry。 */
    SystemConfigKey["UI_THEME"] = "UI_THEME";
})(SystemConfigKey || (SystemConfigKey = {}));
/**
 * 审计日志操作类型
 */
export var AuditAction;
(function (AuditAction) {
    AuditAction["CREATE"] = "CREATE";
    AuditAction["UPDATE"] = "UPDATE";
    AuditAction["DELETE"] = "DELETE";
    AuditAction["LOGIN"] = "LOGIN";
    AuditAction["LOGOUT"] = "LOGOUT";
    AuditAction["ACTIVATE"] = "ACTIVATE";
    AuditAction["DEACTIVATE"] = "DEACTIVATE";
    AuditAction["APPROVE"] = "APPROVE";
    AuditAction["REJECT"] = "REJECT";
    AuditAction["IMPORT"] = "IMPORT";
    AuditAction["EXPORT"] = "EXPORT";
    AuditAction["ASSIGN"] = "ASSIGN";
    AuditAction["UNASSIGN"] = "UNASSIGN";
    AuditAction["REGISTER"] = "REGISTER";
    AuditAction["WITHDRAW"] = "WITHDRAW";
    AuditAction["JUDGE_REQUESTED"] = "JUDGE_REQUESTED";
    AuditAction["JUDGE_APPROVED"] = "JUDGE_APPROVED";
    AuditAction["JUDGE_REJECTED"] = "JUDGE_REJECTED";
    AuditAction["JUDGE_ADDED"] = "JUDGE_ADDED";
    AuditAction["JUDGE_REVOKED"] = "JUDGE_REVOKED";
    AuditAction["JUDGE_REMOVED"] = "JUDGE_REMOVED";
    AuditAction["MAGIC_LINK_SENT"] = "MAGIC_LINK_SENT";
    AuditAction["MAGIC_LINK_USED"] = "MAGIC_LINK_USED";
    AuditAction["LOG_TAMPERED"] = "LOG_TAMPERED";
})(AuditAction || (AuditAction = {}));
/** 哈希链首条记录的 prev_hash 占位符 */
export const HASH_SENTINEL = '<genesis>';
/**
 * 高危审计事件名 — AuditService.log 在判定为高危时通过 EventEmitter2 emit,
 * AuditGateway (Socket, T5) 与 AuditAlertService (站内信, T6) 各自 @OnEvent 监听。
 */
export const AUDIT_HIGH_RISK_EVENT = 'audit.high-risk';
/** 审计结果 */
export var AuditResult;
(function (AuditResult) {
    AuditResult["SUCCESS"] = "SUCCESS";
    AuditResult["FAILURE"] = "FAILURE";
    AuditResult["DENIED"] = "DENIED";
})(AuditResult || (AuditResult = {}));
/** 审计严重级别 */
export var AuditSeverity;
(function (AuditSeverity) {
    AuditSeverity["INFO"] = "INFO";
    AuditSeverity["WARN"] = "WARN";
    AuditSeverity["HIGH"] = "HIGH";
    AuditSeverity["CRITICAL"] = "CRITICAL";
})(AuditSeverity || (AuditSeverity = {}));
/** 轮播图预设背景渐变 */
export const CAROUSEL_BG_GRADIENTS = {
    blue: 'from-blue-800 to-cyan-600',
    purple: 'from-violet-800 to-pink-600',
    green: 'from-emerald-800 to-cyan-600',
    amber: 'from-amber-700 to-orange-500',
    slate: 'from-slate-800 to-slate-600',
    rose: 'from-rose-800 to-pink-600',
};
//# sourceMappingURL=system.js.map